'use client';
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import { useRouter } from 'next/navigation';
import { PrimaryButton, SecondaryButton } from '@egalite/ui/Buttons/GeneralButtons';
import clx from 'classnames';

export default function ButtonsPages({ previousForm = null, className = '', submitDisabled = false, next = null, hideNext = false, hideBack = false }) {
	const router = useRouter();

	const goBack = e => {
		e.preventDefault();
		if (typeof previousForm === 'function') {
			previousForm();
		} else {
			router.push(previousForm, {scroll: true});
		}
	};
	const goForward = e => {
		e.preventDefault();
		if (typeof next === 'function') {
			next();
		} else {
			router.push(next, {scroll: true});
		}
	};

	return (
		<div className={clx("flex flex-col-reverse lg:flex-row justify-between mt-18 lg:mt-12 gap-8", className)}>
			{!hideBack ? (
			<SecondaryButton
				variant="medium"
				type="button"
				onClick={goBack}
				className="basis-full lg:basis-1/2 lg:mt-0 grow shrink"
			>
				Voltar passo
			</SecondaryButton>
			) : null }

			{hideNext ? null : next ? (
				<PrimaryButton
					variant="medium"
					type="button"
					onClick={goForward}
					className="basis-full lg:basis-1/2 lg:mt-0 grow shrink"
				>
					Prosseguir
				</PrimaryButton>
			) : (
				<PrimaryButton
					variant="medium"
					type="submit"
					disabled={submitDisabled}
					className="basis-full lg:basis-1/2 lg:mt-0 grow shrink"
				>
					Salvar e prosseguir
				</PrimaryButton>
			)}
		</div>
	);
}
